// extracted by mini-css-extract-plugin
export default {"projetosMain":"Projects_projetosMain__D+JCC","projectsSection":"Projects_projectsSection__hW6-u","projects":"Projects_projects__jHLS8","linkDiv":"Projects_linkDiv__Q8ZqW"};